import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, dark = false, testId }) => (
  <Reveal>
    <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.3em] text-[#C5A059] mb-4" data-testid={testId ? `${testId}-eyebrow` : undefined}>
      {eyebrow}
    </p>
    <h2
      className={`font-serif-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight ${dark ? "text-[#F8F6F0]" : "text-[#0A192F]"}`}
      data-testid={testId ? `${testId}-title` : undefined}
    >
      {title}
    </h2>
  </Reveal>
);
